import React, { useState, useEffect } from 'react';
import ProductCard from '../components/ProductCard';
import { db } from '../firebase';
import { collection, query, orderBy, onSnapshot } from 'firebase/firestore';

const Products = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  // Fetch products from Firestore
  useEffect(() => {
    const q = query(collection(db, 'products'), orderBy('id', 'asc'));
    
    const unsubscribe = onSnapshot(q, (querySnapshot) => {
      const productsData = [];
      querySnapshot.forEach((doc) => {
        productsData.push({ ...doc.data(), docId: doc.id });
      });
      setProducts(productsData);
      setLoading(false);
    }, (error) => {
      console.error('Error fetching products:', error);
      setLoading(false);
      // Fallback to hardcoded products if Firestore fails
      setProducts([
    {
      id: 1,
      name: 'Adventure Backpack',
      description: 'Durable pet carrier backpack perfect for hiking and outdoor adventures.',
      price: 89.99,
      image: null,
      amazonLink: 'https://amazon.com',
      walmartLink: 'https://walmart.com'
    },
    {
      id: 2,
      name: 'Trail Leash',
      description: 'Heavy-duty retractable leash designed for rugged outdoor terrain.',
      price: 34.99,
      image: null,
      amazonLink: 'https://amazon.com',
      walmartLink: 'https://walmart.com'
    },
    {
      id: 3,
      name: 'Water Bowl Set',
      description: 'Collapsible, portable water bowls for on-the-go hydration.',
      price: 24.99,
      image: null,
      amazonLink: 'https://amazon.com',
      walmartLink: 'https://walmart.com'
    },
    {
      id: 4,
      name: 'Adventure Harness',
      description: 'Comfortable and secure harness for active pets.',
      price: 45.99,
      image: null,
      amazonLink: 'https://amazon.com',
      walmartLink: 'https://walmart.com'
    },
    {
      id: 5,
      name: 'Pet First Aid Kit',
      description: 'Complete first aid kit for outdoor adventures with your pet.',
      price: 39.99,
      image: null,
      amazonLink: 'https://amazon.com',
      walmartLink: 'https://walmart.com'
    },
    {
      id: 6,
      name: 'Cooling Vest',
      description: 'Keep your pet cool during warm weather adventures.',
      price: 54.99,
      image: null,
      amazonLink: 'https://amazon.com',
      walmartLink: 'https://walmart.com'
    },
    {
      id: 7,
      name: 'LED Collar',
      description: 'Rechargeable LED collar for visibility during night walks.',
      price: 29.99,
      image: null,
      amazonLink: 'https://amazon.com',
      walmartLink: 'https://walmart.com'
    },
    {
      id: 8,
      name: 'Travel Food Container',
      description: 'Airtight food storage for extended trips and adventures.',
      price: 19.99,
      image: null,
      amazonLink: 'https://amazon.com',
      walmartLink: 'https://walmart.com'
    },
    {
      id: 9,
      name: 'Paw Protection Boots',
      description: 'Durable boots to protect paws on rough terrain.',
      price: 49.99,
      image: null,
      amazonLink: 'https://amazon.com',
      walmartLink: 'https://walmart.com'
    }
      ]);
    });

    return unsubscribe;
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 py-16 flex items-center justify-center">
        <div className="text-center">
          <div className="text-4xl mb-4">⏳</div>
          <p className="text-xl text-gray-700">Loading products...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50 py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-12">
          <h1 className="text-4xl md:text-5xl font-bold text-forest-green mb-4">
            Our Products
          </h1>
          <p className="text-xl text-gray-700">
            Pet & Pet Supplies Store
          </p>
          <p className="text-lg text-moss-green mt-2">
            Quality gear for adventurous pets and their families
          </p>
        </div>

        {products.length === 0 ? (
          <div className="text-center py-12">
            <p className="text-xl text-gray-600">No products available yet.</p>
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {products.map((product) => (
              <ProductCard key={product.id || product.docId} product={product} showDirectOption={true} />
            ))}
          </div>
        )}

        {/* Info Banner */}
        <div className="mt-16 bg-forest-green text-white rounded-lg p-8 text-center">
          <h2 className="text-2xl font-bold mb-4">Can't Find What You're Looking For?</h2>
          <p className="text-lg mb-6">
            We're constantly expanding our product line. Check back soon or contact us 
            with your specific needs!
          </p>
          <div className="text-4xl">🐾</div>
        </div>
      </div>
    </div>
  );
};

export default Products;
